import React from "react";
import { motion } from "framer-motion";

const variants = {
  up: { hidden: { opacity: 0, y: 40 }, show: { opacity: 1, y: 0 } },
  left: { hidden: { opacity: 0, x: -40 }, show: { opacity: 1, x: 0 } },
  right: { hidden: { opacity: 0, x: 40 }, show: { opacity: 1, x: 0 } },
  fade: { hidden: { opacity: 0 }, show: { opacity: 1 } },
  zoom: { hidden: { opacity: 0, scale: 0.94 }, show: { opacity: 1, scale: 1 } },
};

export const Reveal = ({
  children,
  variant = "up",
  delay = 0,
  duration = 0.8,
  className = "",
  amount = 0.25,
  as: Tag = motion.div,
  ...rest
}) => (
  <Tag
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, amount }}
    variants={variants[variant]}
    transition={{ duration, delay, ease: [0.25, 1, 0.5, 1] }}
    {...rest}
  >
    {children}
  </Tag>
);
